module.exports = __webpack_public_path__ + "img/t8.d38e851e.png";